export default function inserted(el) {
    el.style.height = `calc(100vh - ${el.offsetTop}px)`;
}
